import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BibliothequeComponent } from './bibliotheque/bibliotheque.component';
import { ArchivesComponent } from './archives/archives.component';



const routes: Routes = [
    {
        path: 'archives',
        component: ArchivesComponent
    },
    {
        path: 'bibliotheque',
        component: BibliothequeComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BibliothequeRoutingModule { }
